export default __webpack_public_path__ + "img/sidebar_clients.ba9b27d2.svg";